var _path, _path2, _path3, _rect, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHwp = function SvgHwp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EC",
    d: "M3.5 4A1.5 1.5 0 0 1 5 2.5h18l7.5 8.625V35.5A1.5 1.5 0 0 1 29 37H5a1.5 1.5 0 0 1-1.5-1.5V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F5F6",
    stroke: "#888D96",
    strokeWidth: 0.75,
    d: "M8 .625h17.83l7.295 8.39V33.25c0 .621-.504 1.125-1.125 1.125H8a1.125 1.125 0 0 1-1.125-1.125V1.75c0-.621.504-1.125 1.125-1.125Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    d: "M7.25 22h20.625v3.75a1.5 1.5 0 0 1-1.5 1.5H7.25V22Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 13.5,
    x: 0.875,
    y: 12.25,
    fill: "#1D7FF9",
    rx: 1.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.771 21.875v-6.363h2.391c1.46 0 2.237.887 2.241 2.11-.004 1.216-.79 2.1-2.258 2.1h-1.23v2.153h-1.143Zm1.143-3.094h1.072c.862-.004 1.248-.487 1.248-1.16 0-.681-.386-1.151-1.248-1.151h-1.072v2.311ZM12.38 21.875l-1.793-6.363h1.23l1.152 4.684h.061l1.222-4.684h1.125l1.23 4.693h.053l1.151-4.693h1.231l-1.793 6.363h-1.134l-1.274-4.474h-.044l-1.283 4.474H12.38ZM4.602 21.875v-6.363h1.142v2.698h2.962v-2.698h1.151v6.363H8.706v-2.707H5.744v2.707H4.602Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#888D96",
    d: "M26 .25v8.625h7.5L26 .25Z"
  })));
};
export default SvgHwp;